import { LoginBaseModel } from './login-base-model';

export class GoogleLoginModel extends LoginBaseModel {
    constructor (
        idToken: string
    ) { 
        super();
        this.token = idToken;
    }

    static toJSON(value: GoogleLoginModel): any {
        return {
            id_token: value.token, 
            version: value.version,
            group_invite_mode: value.groupInviteMode,
            group_invite_key: value.groupInviteKey,
            group_code_mode: value.groupCodeMode,
            group_code: value.groupCode,
            // optoinal platform params
            platform: value.platform,
            return_to: value.returnTo,
            brand_id: value.brandId,
            locale_id: value.localeId,
            timestamp: value.timestamp,
            // verification
            site_verify_response: value.site_verify_response   
        };
    }
}
